import { render, staticRenderFns } from "./waitPanel.vue?vue&type=template&id=1c07c5f6"
import script from "./waitPanel.vue?vue&type=script&lang=js"
export * from "./waitPanel.vue?vue&type=script&lang=js"
import style0 from "./waitPanel.vue?vue&type=style&index=0&id=1c07c5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports